var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightCircleBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 2c5.515 0 10 4.486 10 10s-4.485 10-10 10C6.486 22 2 17.514 2 12S6.486 2 12 2z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.557 7.78c.191 0 .383.072.53.218l3.486 3.47a.751.751 0 010 1.063l-3.487 3.472a.749.749 0 11-1.058-1.063L12.982 12l-2.954-2.94a.75.75 0 01.53-1.28z",
    fill: "#ED1B2E"
  })));
}

export default SvgArrowRightCircleBg;